export default {
  filters: {
    formatNumber(value, delimiter = ' ') {
      // Временное решение до исправления бага на бекенде!!!
      if (typeof value !== 'string' || typeof value !== 'number') return value
      const parts = `${value}`.split('.')
      const integerArray = parts[0].split('').reverse()
      const fractionalArray = (parts[1] || '').split('')

      const reducer = (result, symbol, index) => {
        const rest = index % 3

        result.push(symbol)
        if (rest === 2) {
          result.push(delimiter)
        }

        return result
      }

      const newInteger = integerArray.reduce(reducer, []).reverse().join('').trim()
      const newFractional = fractionalArray.reduce(reducer, []).join('').trim()

      return newFractional ? `${newInteger}.${newFractional}` : newInteger
    },

    formatDate(value) {
      const pad = (number) => {
        if (number < 10) {
          return `0${number}`
        }
        return number
      }

      const date = new Date(Date.parse(value))

      const year = date.getFullYear()
      const month = pad(date.getUTCMonth() + 1)
      const day = pad(date.getUTCDate())

      return `${year}-${month}-${day}`
    }
  }
}
